import { createStyles, makeStyles } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey.js';
import React from 'react';
const useStyles = makeStyles(() => createStyles({
  root: {
    top: _ref => {
      let {
        dimensions
      } = _ref;
      return dimensions.top;
    },
    left: _ref2 => {
      let {
        dimensions
      } = _ref2;
      return dimensions.left;
    },
    width: _ref3 => {
      let {
        dimensions
      } = _ref3;
      return dimensions.width;
    },
    height: _ref4 => {
      let {
        dimensions
      } = _ref4;
      return dimensions.height;
    },
    position: 'absolute',
    backgroundColor: grey[600],
    opacity: 0.2
  }
}));
/**
 * Return a styled shape
 * @param dimensions Shape dimensions
 * @returns styled shape
 */

export function ShapeDraft(_ref5) {
  let {
    dimensions
  } = _ref5;
  const classes = useStyles({
    dimensions
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    tabIndex: 0,
    key: `draft-${dimensions.height}-${dimensions.width}`
  });
}
//# sourceMappingURL=shape-draft.js.map